import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IServiceInformation } from '../models/service-information.interface';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';

@Injectable({
  providedIn: 'root'
})
export class ServiceInformationService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}AppointmentInteraction`
  //private readonly apiUrl = 'http://localhost:5010/company/AppointmentInteraction';

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  addServiceInformation(appointmentId: string, serviceInformation: IServiceInformation): Observable<ResponseDefault<string>> {
    return this.http.post<ResponseDefault<string>>(`${this.apiUrl}/OperatorSendServiceInformation/${appointmentId}`, serviceInformation);
  }
}
